<template>
    <div class="view">

        <Head @ck="menuOpen = true">{{ $t("menu.myDoc")}}</Head>
        <ExamEndView :total="total" :num="num" :pa="pa"></ExamEndView>
    </div>

</template>

<script>
import ExamEndView from '@/components/ExamEndView'
import mainDelegate from '@/delegate/mainDelegate'
export default {
    name: 'ExamEndShow',
    mixins: [mainDelegate],
    data() {
        return {
            total: 0,
            num: 0
        }
    },
    computed: {
        pa() {
            return ((this.num / this.total * 100) << 1) >> 1
        }
    },
    components: {
        ExamEndView
    },
    mounted() {
        let examResult = this.examEndMata.ExamResult.split('/')
        this.total = examResult[1] * 1
        this.num = examResult[0] * 1
    }
}
</script>

<style lang="less" scoped>
@import 'val.less';
@import 'view.less';
</style>



// WEBPACK FOOTER //
// src/page/ExamEndShow.vue